import { AnimatePresence, motion } from "framer-motion";
import { Truck, X } from "lucide-react";
import { useEffect, useState } from "react";

/**
 * Bottom-left free-shipping nudge. Fires ~5s after the first non-admin
 * page load, once per session (sessionStorage-gated), auto-dismisses
 * after 12s if untouched. Non-blocking pill toast so it doesn't fight
 * with the WelcomePopup / age gate on first paint.
 */
const KEY = "bb_free_ship_seen_v1";

export default function FreeShippingPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY) === "1") return;
    const t = setTimeout(() => {
      // Don't stack with the age gate / welcome popup on the same tick
      if (document.querySelector('[role="dialog"]')) return;
      setOpen(true);
      sessionStorage.setItem(KEY, "1");
    }, 5000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => setOpen(false), 12000);
    return () => clearTimeout(t);
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ type: "spring", damping: 22, stiffness: 260 }}
          data-testid="free-shipping-popup"
          className="fixed bottom-6 left-6 z-40 max-w-sm rounded-2xl border border-[#FF3D8B]/40 bg-black/85 backdrop-blur-xl shadow-[0_0_40px_rgba(255,61,139,0.25)] px-5 py-4 flex items-start gap-3 text-white"
        >
          <div className="shrink-0 w-9 h-9 rounded-full bg-[#FF3D8B]/15 text-[#FF3D8B] flex items-center justify-center">
            <Truck size={16} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-widest text-[#A855F7]">
              Little something extra
            </div>
            <div className="font-display text-lg leading-tight mt-0.5">
              Free shipping on orders over <span className="text-[#FF3D8B]">$10</span>
            </div>
            <div className="text-white/60 text-xs mt-1">
              Grab any two scents and we'll cover the postage.
            </div>
          </div>
          <button
            onClick={() => setOpen(false)}
            aria-label="Dismiss offer"
            data-testid="free-shipping-close-btn"
            className="text-white/40 hover:text-white transition-colors -mt-1 -mr-1 p-1"
          >
            <X size={14} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
